import {DateTime} from "luxon";

const PlanTrial = "trial";
const PlanPaying = "paying";
const PlanTest = "test";
const PlanBlocked = "blocked";

const ProductPrivateUser = "private user"; // Privatanwender
const ProductSalesTeam = "sales team"; // Sales team

const GroupDefault = "default"; // default user (i.e. Privatanwender oder Team Member)
const GroupAdmin = "admin";
const GroupTeamLeader = "team leader"; // Sales team
const GroupDirector = "director"; // Sales team

const MemberInvited = "eingeladen"; // member account does not exist but an invitation has been sent
const MemberJoined = "Mitglied"; // member account is linked into the team


const AboFree = 'Free';
const AboSilver = '396016';
const AboGold = '410225';

const EXPIRATION_DAYS = 30;

export default {
    // plan (subscription status)
    PlanTrial,
    PlanPaying,
    PlanTest,
    PlanBlocked,
    // products
    ProductPrivateUser,
    ProductSalesTeam,
    // user groups
    GroupDefault,
    GroupAdmin,
    GroupTeamLeader,
    GroupDirector,
    // membership
    MemberInvited,
    MemberJoined,
    // Abos
    AboFree,
    AboSilver,
    AboGold,
    //
    NumActisFree: 10,
    NumActisSilver: 10,
    NumActisGold: 100,

    getProductName(prod) {
        switch (prod)
        {
            default:
            case ProductPrivateUser:
                return "Aimz";
            case ProductSalesTeam:
                return "Team Dashboard";
        }
    },

    getAboName(productId) {
        if (!productId)
            return "FREE";
        switch (productId)
        {
            default:
            case AboFree:
                return "FREE";
            case AboSilver:
                return "FREE";
            case AboGold:
                return "PRO";
        }
    },

    numBereiche(product) {
        if (!product)
            return 5;
        switch (product) {
            case AboFree:
                return 5;
            case AboSilver:
                return 5;
            case AboGold:
                return 10;
        }
    },

    numAktivities(product) {
        if (!product)
            return 3;
        switch (product) {
            case AboFree:
                return 10;
            case AboSilver:
                return 10;
            case AboGold:
                return 100;
        }
    },
    getExpirationDate(user) {
        console.log("getExpirationDate", user);
        var cd=user.creationDate || user.CreationDate;
        if (!cd || cd.startsWith("0001"))
            cd="2020-01-01";
        var creationDate=DateTime.fromJSDate(new Date(cd));
        var date=user.freeExpirationDate || user.FreeExpirationDate;
        if (!date || date.startsWith("0001")) {
            var expDate=creationDate.plus({ days: EXPIRATION_DAYS });
            if (expDate < DateTime.fromISO("2021-10-31"))
                date = "2021-10-31";
            else
                date = expDate.toISODate();
        }
        return date;
    },

}